<template>
  <VAutocomplete
    :label="$t('workOrders.workOrderVisitSelection')"
    :items="displayWorkOrderTypes"
    :rules="{ required: false }"
    :loading="loading"
    :itemValue="itemValue"
    :value="value"
    outlined
    data-cy="workOrderVisitSelection"
    @input="updateData"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';

export default {
    components: {
        VAutocomplete,
    },
    props: {
        itemValue: {
            type: String,
            default: 'id',
        },
    },
    data() {
        return {
            loading: false,
            workOrderTypes: [],
            value: [],
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
            'teamMainLang',
            'roles',
        ]),
        displayWorkOrderTypes() {
            return this.workOrderTypes.map(type => ({
                name: type.name[this.userLang] || type.name[this.teamMainLang],
                id: type.id,
                key: type.key,
            }));
        },
    },
    async created() {
        await this.getWorkOrderTypes();
        this.$emit('disabled', true);
        this.$store.dispatch('clearTabs');
    },
    methods: {
        async getWorkOrderTypes() {
            // workOrders types are shown base on user role
            const { data } = await this.$rq.getWorkOrderTypes();
            const [role] = Object.values(this.roles);
            this.workOrderTypes = data.map(type => {
                if (type.roles.find(r => r.key === role.key)) return type;
                return null;
            }).filter(Boolean);
        },
        updateData(select) {
            this.$emit('sendData', {
                selectedWorkOrdertypes: [select],
            });
            if (select) {
                this.$emit('disabled', false);
            }
        },
    },
};
</script>
